import { useEffect, useState } from 'react';
import '@photo-sphere-viewer/core/index.css';
import * as exifr from 'exifr';
import CompanyPanoViewerLayer from './CompanyPanoViewerLayer';
import CompanyImageViewerLayer from './CompanyImageViewerLayer';
import { checkImageFromBlob, fetchImageBlob } from 'data/data';

export function CompanyEquipmentViewerLayer({file, fileId, mapsId}) {
    const [imageUrl, setImageUrl] = useState(null);
    const [is360, setIs360] = useState(null);

    useEffect(() => {
      let objectUrl;

      const setImageFromFile = async () => {
        let fileUrl = fileId
          ? window.RUNTIME_CONFIG.REACT_APP_API_URL + "/api/download/" + fileId
          : file || "https://photo-sphere-viewer-data.netlify.app/assets/sphere.jpg";
        // console.log(fileUrl)
        try {
          // const response = await fetch(fileUrl);
          // const blob = await response.blob();
          const blob = await fetchImageBlob(fileUrl);
          const { url, is360 } = await checkImageFromBlob(blob);
          objectUrl = url;
          setImageUrl(url);
          setIs360(is360);
        } catch (error) {
          console.error("image file download fail:", error);
        }
      };

      setImageFromFile();

      // ✅ 언마운트 시 URL 해제
      return () => {
        if (objectUrl) URL.revokeObjectURL(objectUrl);
      };
    }, [file, fileId]);

    return (
      <>
        {imageUrl && is360 === true && <CompanyPanoViewerLayer fileUrl={imageUrl} mapsId={mapsId} />}
        {imageUrl && is360 === false && <CompanyImageViewerLayer fileUrl={imageUrl} mapsId={mapsId} />}
        {is360 === null && <div>Loading image...</div>}
      </>
    )
  }
  
  export default CompanyEquipmentViewerLayer;
  